<script>
import { Link } from 'svelte-navigator';
import { TopBarTitle } from './theme';

let height;
$: height = window.innerHeight;
</script>

<div class="header row">
  <!-- <div class="whitebox" /> -->

  <div class="row vcenter between f1">
    <Link to="/">
      <div class="row vcenter">
        <div class="logo-box-mobile row">
          <div class="logo logo-mobile-small" />
          <!-- <div class="slant" /> -->
        </div>
        <div class="title">{@html TopBarTitle}</div>
      </div>
    </Link>

    <div class="row vcenter">
      <div class="poweredby mr-16">Powered by | <span>PARALLEL.LIVE</span></div>
      <Link to="/help">
        <img src="/img/help-icon.svg">
      </Link>
    </div>
  </div>
</div>

<div class="content col hcenter">
  <slot />
</div>

<div class="footer centercenter">
  <div class="row vcenter">
    <a class="link" href="https://app.termly.io/document/privacy-policy/eca88e97-151c-4de0-8259-d68307e2ff0d" target="_blank">Privacy Policy</a>
    <img src="/img/logo-footer.png" />
    <a class="link" href="https://app.termly.io/document/terms-of-use-for-website/614c76e5-2c03-48c0-ba36-b3b5d091da8b" target="_blank">Terms of Use</a>
  </div>
</div>


<style lang="scss">
@import './util';
@import './theme';

$headerHeight: 5rem;
$footerHeight: 72px;

.logo-mobile-small {
  @include landscape {
    background-image: url('/img/logo-sm.png');
    width: 72px;
    background-size: 90%;
  }
}

.logo-box-mobile {
  @include landscape {
    padding-right: 12px;
  }
}

.header {
  position: fixed;
  height: $headerHeight;
  right: 0;
  left: 0;
  top: 0;
  z-index: 1000;
  padding: 0 24px;
  background-color: $topbar-background-color;
  color: $topbar-foreground-color;

  @include tablet {
    padding-right: 16px;
  }
}

.whitebox {
  width: 24px;
  background-color: white;

  @include tablet {
    width: 16px;
  }
}

.title {
  margin-left: 16px;
  font-weight: normal;
  font-size: 32px;

  @include landscape {
    font-size: 13px;
  }
}

.poweredby {
  font-family: $secondary-font;
  font-size: 20px;
  font-weight: 300;

  span {
    font-weight: 800;
  }

  @include mobile {
    display: none;
  }
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: $footerHeight;
  background-color: $registration-footer-background-color;
  color: $registration-footer-foreground-color;
  font-family: $secondary-font;
  padding: 0 40px;
  font-size: 16px;
  font-weight: 350;
}

.footer img {
  height: 72px;
  padding: 12px;

  @include mobile {
    display: none;
  }
}
.footer .link {
  margin: 0 40px;
  white-space: nowrap;

  @include mobile {
    margin: 0 20px;
  }
}

.content {
  background-size: cover;
  background-position: center;
  background-image: $registration-background;
  background-attachment: fixed;
  min-height: 100vh;

  margin-top: $headerHeight;
  padding: 2rem 0 calc(2rem + #{$footerHeight}) 0;
  
  @include landscape {
    padding: 2rem 0 $footerHeight 0;
  }
}
</style>